"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddonsList;
require("core-js/modules/esnext.iterator.map.js");
var _ListSubheader = _interopRequireDefault(require("@mui/material/ListSubheader"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _AddonItem = _interopRequireDefault(require("./AddonItem"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function AddonsList(_ref) {
  let {
    addons
  } = _ref;
  const parentRef = /*#__PURE__*/(0, _react.createRef)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _stylesModule.default.container,
    ref: parentRef,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.default, {
      dense: true,
      sx: {
        width: "100%",
        maxWidth: 360,
        bgcolor: "background.paper"
      },
      component: "nav",
      "aria-labelledby": "nested-list-subheader",
      subheader: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListSubheader.default, {
        component: "div",
        id: "nested-list-subheader",
        children: addons.map((addon, idx) => {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddonItem.default, {
            addon: addon,
            parentRef: parentRef
          }, idx);
        })
      })
    })
  });
}